import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { ViewKey } from '../nav/navModel';

/** Encabezado de vista (clase .top del prototipo): título, subtítulo y acciones. */
export function ViewHeader({ view, actions }: { view: ViewKey; actions?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="top">
      <div>
        <h1 id="title">{t(`views.${view}.title`)}</h1>
        <p id="subtitle">{t(`views.${view}.subtitle`)}</p>
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </div>
  );
}
